"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacerContainer = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _styledUtils = require("@sloth-system/styled-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyLine(props) {
  if (props.line) {
    let colorValue = typeof props.line === "string" ? props.line : "neutrals.0";
    return `&:after{
      position: absolute;
      left: 50%;
      top: 0; 
      width: 2px;
      height: 100%;
      transform: translateX(-50%);
      background: ${(0, _styledUtils.color)(colorValue)(props)};
      content: "";
    }`;
  }

  return "";
}

let SpacerContainer = _native.default.View`
  position: relative;
  width: ${props => (0, _styledUtils.space)(props.size)(props)};
  height: ${props => (0, _styledUtils.space)(props.size)(props)};
  ${applyLine}
`;
exports.SpacerContainer = SpacerContainer;